'use client';

import type { HTMLAttributes } from 'react';

import { useCartRaffleAccordion } from '@/app/(main)/meus-titulos/_components/TicketsContent/CartRaffleAccordion/hooks/useCartRaffleAccordion';
import { cn } from '@/libs';

import { Icon } from '../ui';

type WinnerTicketProps = HTMLAttributes<HTMLDivElement> & {
  value: string;
  ticketId?: string;
};

export const WinnerTicket = ({ value, className, ticketId }: WinnerTicketProps) => {
  const { openCartRaffleAccordionDrawer } = useCartRaffleAccordion();
  return (
    <div
      className={cn(
        'relative flex items-center justify-center text-sm w-full h-auto',
        className,
      )}
      onClick={() =>
        ticketId && openCartRaffleAccordionDrawer({ id: ticketId, sequence: value })
      }
    >
      <Icon.Ticket />
      <div className="absolute flex flex-row top-1/2 -translate-y-1/2 w-full items-center justify-center">
        <span className="text-primary-foreground font-extrabold tracking-widest text-center">
          {value}
        </span>
      </div>
    </div>
  );
};
